import { ArrowForward } from "@material-ui/icons";
import { Box } from "@mui/material";
import { Col, Row } from "antd";
import axios from "axios";
import { ModalError, PrimaryTextButton, TablePagination } from "components";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors } from "utils";
import Chip from "../../../mpisLandingComponent/Chip/Chip";
import Layout from "../../../mpisLandingComponent/Layout";
import Publisher from "../../../mpisLandingComponent/Publisher";
import "./Edukasi.css";
import { getTotalPage } from "lib";

export default function Edukasi() {
  const history = useHistory();
  const [edukasi, setEdukasi] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 3,
    type: "edukasi",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);

  const getSpan = count => (count === 1 ? 24 : count === 2 ? 12 : 8);
  const handleDetailBerita = res => {
    history.push({
      pathname: `/artikel/detail/${res?.article_id}`,
      state: res,
    });
  };

  const getEdukasi = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/article/public`, {
        params: queryParams,
      });
      const { meta, data } = res.data;
      setEdukasi(data);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };

  useEffect(() => {
    getEdukasi();
  }, []);

  return (
    <Layout>
      <div className="edukasi">
        <div className="container">
          <h1>Insight for You</h1>
          <Box height="576px">
            <Row style={{ height: "100%" }} gutter={16}>
              {edukasi?.length > 0 && (
                <Col
                  onClick={() => handleDetailBerita(edukasi?.[0])}
                  span={16}
                  style={{ height: "100%" }}
                  className="banner-wrapper"
                >
                  <img
                    src={edukasi?.[0]?.banner_image}
                    alt=""
                    className="image"
                    style={{ height: "100%", width: "100%" }}
                  />
                  <div className="content">
                    <Chip color="white" title="Education" />
                    <h1 style={{ color: "white", margin: 0 }}>
                      {edukasi?.[0]?.title}
                    </h1>
                    <Publisher
                      publisher={edukasi?.[0]?.publisher_name}
                      day={edukasi?.[0]?.range_date}
                      color="white"
                      fontSize="14px"
                    />
                  </div>
                </Col>
              )}
              {edukasi?.length > 1 && (
                <Col
                  span={8}
                  style={{
                    height: "100%",
                  }}
                >
                  {edukasi?.slice(1, 3).map((res, i) => (
                    <div
                      key={i}
                      style={{
                        height: "50%",
                        paddingBottom: "9px",
                        position: "relative",
                      }}
                      className="banner-wrapper"
                      onClick={() => handleDetailBerita(res)}
                    >
                      <img
                        src={res?.banner_image}
                        alt=""
                        className="image"
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                        }}
                      />
                      <div className="content">
                        <Chip color="white" title="Education" />
                        <h2 style={{ color: "white", margin: 0 }}>
                          {res?.title}
                        </h2>
                        <Publisher
                          publisher={res?.publisher_name}
                          day={res?.range_date}
                          color="white"
                          fontSize="14px"
                        />
                      </div>
                    </div>
                  ))}
                </Col>
              )}
            </Row>
          </Box>
          <hr className="gap" />
          <h1>Latest Post</h1>
          <div style={{ marginTop: "25px" }} className="row-content">
            <Row style={{ marginTop: "100px" }}>
              {edukasi?.map((res, i) => {
                return (
                  <Col
                    key={i}
                    span={getSpan(edukasi?.length)}
                    style={{
                      height: "180px",
                      display: "flex",
                      flexDirection: "row",
                      marginBottom: "54px",
                    }}
                    gap={16}
                  >
                    <div style={{ flex: 2.5 }}>
                      <img
                        src={res?.banner_image}
                        alt=""
                        style={{
                          height: "100%",
                          borderRadius: "10px",
                          width: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        flex: 3,
                        paddingLeft: "24px",
                        marginRight: "20px",
                      }}
                    >
                      <div>
                        <Chip
                          title="Education"
                          type={res.type}
                          color="#9545EB"
                        />
                        <h2 style={{ marginTop: "5px", marginBottom: "0px" }}>
                          {res?.title?.length > 40
                            ? res?.title?.substring(
                                0,
                                edukasi?.length <= 2 ? 40 : 16
                              ) + "..."
                            : res?.title}
                        </h2>
                        <Publisher
                          publisher={res?.publisher_name}
                          day={res?.range_date}
                        />
                        <p
                          style={{
                            fontSize: "16px",
                            color: "#687083",
                            margin: "0px",
                          }}
                          dangerouslySetInnerHTML={{
                            __html:
                              res?.content?.length > 70
                                ? res?.content?.substring(0, 20) + "..."
                                : res?.content,
                          }}
                        />
                        <PrimaryTextButton
                          label="Read More"
                          onClick={() => handleDetailBerita(res)}
                          endIcon={<ArrowForward />}
                          iconColor="#9545EB"
                        />
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
          <TablePagination
            page={queryParams?.page}
            pageCount={tableTotalPage}
            handleChangePage={(_, page) =>
              setQueryParams(prev => ({ ...prev, page }))
            }
            justifyContent="center"
          />
        </div>
      </div>
    </Layout>
  );
}
